import { Button, Divider, Col } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import React from 'react';
import { PlusOutlined } from "@ant-design/icons";
import { Link } from 'react-router-dom';
import PartnerList from './partners/PartnerList';

export const PartnershipView = () => {
  return (
    <>
      <div className="content">
        {/* <PageHeader
        ghost={false}
        title="Partners"
        // subTitle="Page shows list of partners"
        extra={[
          <Button type="primary" key="1">
          <Link key="2" to='/partnership/new'>  
            New Partner
          </Link></Button>
        ]}
      ></PageHeader> */}
        <Col xs={24}>
          <h1 className="center-align">Partners</h1>
        </Col>
        <Col xs={24} sm={24}>
        <Link key="2" to='/partnership/new'>
          <Button type="primary" key="1" className="add-button" icon={<PlusOutlined />}>
            &nbsp; Add New Partner
          </Button>
        </Link>
        </Col>
        <PartnerList />
      </div>
    </>
  )
}
